import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { PartnerConfigProvider } from 'src/shared/contexts/partnerConfigContext';

type LegacyPartnerConfigBoundaryProps = {
  children: ReactNode;
};

export function LegacyPartnerConfigBoundary({
  children,
}: LegacyPartnerConfigBoundaryProps) {
  const { pathname } = useLocation();

  if (pathname.startsWith('/fastcomp')) {
    return <>{children}</>;
  }

  return <PartnerConfigProvider>{children}</PartnerConfigProvider>;
}
